<div *ngIf="inlineMsg?.value" class="notd-msg-saved {{currentValue?.css}}">{{inlineMsg.value}}</div>
